// The Financials source round-trip's back control. Delegates to the shared
// BackBar (floating variant) so it looks + behaves identically to every other
// back affordance in the app; this wrapper only pins the Financials label +
// hint and keeps the render-gate predicate Financials uses.
//
// Financials' own return STATE (summaryFocusRow) is intentionally left as-is —
// this pass unifies the affordance, not the working Financials restore logic.

import { createElement } from "react";
import BackBar from "./BackBar";

export const BACK_LABEL = "← Back to Financials";

interface Props {
  onBack: () => void;
}

export default function BackToSummaryBar({ onBack }: Props) {
  return createElement(BackBar, {
    label: BACK_LABEL,
    hint: "Viewing the source for a Financials row",
    onBack,
    variant: "floating",
  });
}

// Whether the Back-to-Financials control should show: the user is on the record
// destination AND a return to a Financials row is pending.
export function shouldShowBackToSummary(
  tab: string,
  summaryFocusRow: unknown,
): boolean {
  return tab === "records" && summaryFocusRow != null;
}
